<template>
	<a
		:href="product.url"
		class="c-searchProduct"
		:class="{ 'c-searchProduct--inline': inline }"
	>
		<!-- Absolute -->
		<div class="c-searchProduct__labels">
			<Labels
				v-if="product.labels.length"
				:labels="product.labels"
				:inline="inline"
				:newProduct="false"
				:saleProduct="false"
			></Labels>
		</div>

		<!-- Image -->
		<div
			class="c-searchProduct__image"
			:class="product.image.whitespace ? 'whitespace' : ''"
		>
			<img :src="product.image.src" :alt="product.image.title" />
		</div>

		<!-- Info -->
		<div class="c-searchProduct__info">
			<Rating :review="product.rating"></Rating>
			<p class="p-disclaimer">{{ product.brand }}</p>
			<h3>{{ product.title }}</h3>
		</div>
	</a>
</template>

<script>
import Labels from "@/vue/components/objects/Labels.vue";
import Rating from "@/vue/components/objects/Rating.vue";
import CatalogVariant from "@/vue/components/commerce/objects/CatalogVariant.vue";
import Favorite from "@/vue/components/commerce/Favorite.vue";

export default {
	name: "SearchProduct",
	props: {
		product: Object,
	},
	components: {
		Labels,
		Favorite,
		Rating,
		CatalogVariant,
	},

	data: () => {
		return {
			inline: true,
		};
	},

	created() {},
	methods: {},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables";
@import "@backend/scss/abstracts/mixins";

.c-searchProduct {
	max-width: 285px;
	width: 100%;
	position: relative;
	background-color: $c-white;
	overflow: visible;

	display: flex;
	flex-direction: column;

	&__labels {
		position: absolute;
		top: 16px;
		left: 16px;

		.o-labels {
			flex-direction: column;
		}
	}

	&__favorite {
		pointer-events: all;
		position: absolute;
		top: 9px;
		right: 9px;
	}
	.whitespace {
		padding: 20px;
	}
	&__image {
		width: 100%;
		aspect-ratio: 1/1;

		img {
			width: 100%;
		}
	}

	&__info {
		display: flex;
		flex: 1;
		flex-direction: column;
		align-items: center;
		padding-inline: 5px;

		.c-rating {
			margin-top: 16px;
		}

		.p-disclaimer {
			@include text-overflow(1);
			text-align: center;
			margin-top: 16px;
		}

		h3 {
			@include text-overflow(2);
			text-align: center;
			margin-top: 8px;
		}

		.ccf-price {
			margin-top: 3px;
			margin-bottom: 16px;
		}

		.button {
			margin-top: 16px;
			width: 100%;
			display: flex;
			flex: 1;
			align-items: flex-end;
			justify-content: center;

			transition: $t-hover;
			opacity: 0;
			margin-bottom: 24px;
			pointer-events: all;

			div {
				justify-content: center;
				width: 100%;
				display: flex;
				flex: 1;
			}

			.o-btn {
				width: 100%;
				max-width: 210px;
				padding-inline: 0;
			}
		}
	}

	&::before {
		transition: $t-hover;
		pointer-events: none;
		content: "";
		position: absolute;
		top: 0;
		left: 0;

		width: 100%;
		height: 100%;
	}

	&:hover {
		&::before {
			transition: $t-hover;
			box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
		}
		.c-searchProduct {
			&__info {
				.button {
					transition: $t-hover;
					opacity: 1;
				}
			}
		}
	}

	&--loading {
		pointer-events: none;
		width: 100%;
		max-width: 100%;
		.c-searchProduct {
			&__labels {
				opacity: 0;
			}
			&__favorite {
				opacity: 0;
				pointer-events: none;
			}
			&__image {
				@include loader-skeleton();
			}

			&__info {
				.c-rating,
				.p-disclaimer,
				h3,
				.price {
					@include loader-skeleton();
				}

				.p-disclaimer {
					min-width: 50px;
				}

				h3 {
					min-width: 100px;
				}

				.ccf-price {
					min-width: 60px;
				}

				.button {
					pointer-events: none;
				}
			}

			&:hover {
				&::before {
					display: none;
				}
			}
		}
	}

	&--inline {
		flex-direction: row;

		&:hover {
			position: relative;
			z-index: 15;
		}

		.c-searchProduct {
			&__image {
				width: 135px;
				aspect-ratio: 1/1;
				img {
					max-width: 135px;
				}
			}

			&__info {
				align-items: flex-start;
			}

			&__favorite {
				display: none;
			}
		}

		.o-labels__label {
			height: 20px;
			padding-inline: 4px;
			svg {
				height: 13px;
				margin-right: 2px;
			}
			span {
				font-size: 10px;
			}
		}

		.c-rating {
			margin-top: 20px;
		}

		.p-disclaimer {
			margin-top: 6px;
		}

		h3 {
			margin-top: 4px;
			text-align: left;
		}

		.button {
			position: absolute;
			right: 0;
			top: 0;
			margin-top: 10px;

			.icon {
				position: relative;
				background: #f7ecee;
				width: auto;
				flex: unset;
				border-radius: 100%;
				height: 34px;
				width: 34px;
				display: flex;
				justify-content: center;
				align-items: center;
				svg {
					width: 15px;
					height: auto;
				}

				.toolTip {
					position: absolute;
					right: 41px;
					white-space: nowrap;
					font-size: 10px;
					background: #2b3f6c;
					width: auto;
					padding: 0px 7px;
					color: #fff;
					border-radius: 3px;
					text-transform: uppercase;
					font-weight: 700;
					opacity: 0;
					transition: all $t-hover;
					pointer-events: none;
					touch-action: none;

					&::after {
						display: block;
						content: "";
						position: absolute;
						width: 0;
						height: 0;
						border-style: solid;
						border-width: 4px 0 4px 5px;
						border-color: transparent transparent transparent #2b3f6c;
						right: -5px;
						top: 50%;
						margin-top: -4px;
					}
				}

				.o-loader {
					width: 20px;
					max-width: 20px;
					justify-content: center;
					align-items: center;
				}

				.ca-addedToCart {
					svg {
						width: auto;
						height: 6px;
						margin-top: 4px;
						path {
							stroke: #2b3f6c;
						}
					}
				}

				&:hover {
					.toolTip {
						opacity: 1;
						right: 45px;
					}
				}
			}

			.o-btn {
				min-height: unset;
				height: 34px;
				min-width: 135px;
				width: auto;
				padding: 0 15px;
			}
		}
	}
}

@media all and (max-width: 550px) {
	.c-searchProduct {
		&__labels {
			top: 8px;
			left: 8px;
		}

		&__favorite {
			top: 8px;
			right: 8px;
		}

		&__info {
			padding-inline: 0px;

			.c-rating {
				margin-top: 8px;
			}

			.p-disclaimer {
				margin-top: 8px;
			}

			h3 {
				margin-top: 8px;
			}

			.price {
				min-height: 40px;
				margin-top: 8px;
				gap: 0;
				flex-direction: column;
				justify-content: flex-end;
			}

			.button {
				margin-top: 16px;
				margin-bottom: 0px;
			}
		}
	}
}

@media all and (max-width: 500px) {
	.c-searchProduct {
		.whitespace {
			padding: 10px;
		}
	}
}

@media all and (max-width: 400px) {
	.c-searchProduct {
		.whitespace {
			padding: 0px;
		}

		&--inline {
			gap: 10px;

			.c-searchProduct {
				&__image {
					width: 100px;
					img {
						max-width: 100px;
					}
				}
			}
		}
	}
}

@media (hover: none) {
	.c-searchProduct {
		&__info {
			.button {
				margin-bottom: 0;
				opacity: 1;
			}
		}

		&::before {
			display: none;
		}
	}
}
</style>
